import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductShield } from "./UseProductShield";

export default function ShieldAutoComplete(props) {
  const { getAllShieldList } = UseProductShield();
  const [productShieldRes, setProductShieldRes] = useState();
  const [selectedShield, setSelectedShield] = useState();

  useEffect(() => {
    getAllShieldList((shields) => {
      setProductShieldRes(shields);
    });
  }, []);

  useEffect(() => {
    if (productShieldRes && props.selectedShieldID) {
      setSelectedShield(
        productShieldRes.shields.find((m) => m.id == props.selectedShieldID)
      );
    }
  }, [productShieldRes, props.selectedShieldID]);

  useEffect(() => {
    if (selectedShield) {
      props.setter({
        ...props.lvl2State,
        shieldID: selectedShield.id,
      });
    }
  }, [selectedShield]);

  return productShieldRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedShield ? selectedShield : ""}
        options={productShieldRes.shields ? productShieldRes.shields : []}
        getOptionLabel={(shields) => (shields.name ? shields.name : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="محفظه محصول" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name ? option.name : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedShield(newValue);
          } else {
            setSelectedShield();
            props.setter({
              ...props.lvl2State,
              shieldID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllShieldList((shields) => {
            setProductShieldRes(shields);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/productshield" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
